import { StyleSheet } from 'react-native'
import theme from '../../../../../theme'

const styles = StyleSheet.create({
    containerItem: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    container: {
        paddingVertical: 10,
    },
    title: {
        fontSize: 15,
        color: theme.colors.textPrimary,
        fontWeight: 'normal',
        textAlign: 'left',
        lineHeight: 18,
        marginVertical: 8,
        marginHorizontal: 12,
    },
    description: {
        fontSize: 14,
        color: theme.colors.textSecondary,
        fontWeight: 'normal',
        textAlign: 'left',
        lineHeight: 16,
        marginVertical: 8,
        marginHorizontal: 12,
    },
    width: {
        flex: 1,
    },
    flexDirectionRow: {
        flexDirection: 'row',
    },
    divider: {
        flex: 1,
        borderWidth: 0.5,
        borderColor: theme.colors.lightGray,
        marginHorizontal: 12,
    },
    spacer: {
        height: 4,
    },
    spacer1: {
        height: 12,
    },
})

export default styles
